import type { PageContentApiItem } from '@/app/lib/api/types-api'

import { sanitizeHtml } from './sanitizeHtml'
import { toPlainText } from './toPlainText'

/**
 * Texto bajo el título de las PLPs (promociones, subcategoría…) — el `body`
 * del primer elemento de `page_contents` que lo traiga con contenido. Puede
 * llegar como texto plano o HTML: se sanea con el subconjunto "en línea"
 * (`sanitizeHtml(body, { inline: true })`, mismo criterio que
 * `ManualPageIntro`) porque se inserta dentro del `<p>` de `PageIntro`.
 * Cadena vacía si ningún elemento aporta texto: el llamante omite entonces la
 * descripción.
 *
 * Solo en servidor: DOMPurify no debe entrar en el bundle de cliente.
 */
export function resolvePageContentBody(items: PageContentApiItem[] | null | undefined): string {
  if (!Array.isArray(items)) return ''

  for (const item of items) {
    if (item.body && toPlainText(item.body)) return sanitizeHtml(item.body, { inline: true })
  }

  return ''
}
